module.exports = "<app-loading></app-loading>"


//////////////////
// WEBPACK FOOTER
// ./src/app/root/root.component.html
// module id = ./src/app/root/root.component.html
// module chunks = main